import { useCustomerCreateStore } from './useCustomerCreateStore';

export const customModalsConfig = [
  {
    key: 'createCustomer',
    import: () => import('../views/CreateCustomer'),
    store: useCustomerCreateStore,
    override: true,
  },
];